import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ContactUs = () => {
  useEffect(() => {
    document.title = "Contact Us - MedEngage";
  }, []);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && (
        <div
          className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div className="custom-spinner"></div>
        </div>
      )}

      <main>
        {/* BREADCRUMBS */}
        <section className="ul-breadcrumb ul-section-spacing">
          <div className="ul-container">
            <h2 className="ul-breadcrumb-title">Contact us</h2>
            <ul className="ul-breadcrumb-nav">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <span className="separator">
                  <i className="flaticon-right"></i>
                </span>
              </li>
              <li>Contact us</li>
            </ul>
          </div>
        </section>

        {/* Contact Info Section */}
        <section className="py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                {/* Header */}
                <div className="text-center mb-5">
                  <h2 className="fw-bold text-dark mb-3">Get In Touch</h2>
                  <p className="text-muted fs-5">
                    We're here to help you with all your queries and
                    applications
                  </p>
                </div>

                {/* Registration & Application Card */}
                <div className="row g-4 mb-5">
                  <div className="col-12">
                    <div className="card border-0 shadow-sm rounded-5 h-100 position-relative overflow-hidden">
                      <div className="card-body bg-light p-4 p-md-5">
                        <div className="d-flex align-items-start mb-4">
                          <div
                            className="bg-success bg-gradient text-white rounded-circle d-flex align-items-center justify-content-center me-4 flex-shrink-0"
                            style={{ width: "40px", height: "40px" }}
                          >
                            <i className="fa fa-file fs-4"></i>
                          </div>
                          <div>
                            <h3 className="fw-bold text-dark mb-2">
                              Registration & Application
                            </h3>
                            <p className="text-muted mb-3">
                              Submit your applications and handle registration
                              processes
                            </p>
                          </div>
                        </div>

                        <div className="d-flex flex-column flex-md-row gap-3 w-100">
                          <div className="d-flex align-items-center gap-2">
                            <i className="fa fa-envelope text-success"></i>
                            <a
                              href="mailto:application@med-engage.com"
                              className="text-success fw-semibold info-link"
                            >
                              application@med-engage.com
                            </a>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <i className="fa fa-envelope text-success"></i>
                            <a
                              href="mailto:support@med-engage.com"
                              className="text-success fw-semibold info-link"
                            >
                              support@med-engage.com
                            </a>
                          </div>
                        </div>
                      </div>

                      <div
                        className="position-absolute bottom-0 start-0 w-100"
                        style={{
                          height: "4px",
                          background:
                            "linear-gradient(90deg, #25D366, #128C7E)",
                        }}
                      ></div>
                    </div>
                  </div>

                  {/* General Queries Card */}
                  <div className="col-12">
                    <div className="card border-0 shadow-sm rounded-5 h-100 position-relative overflow-hidden">
                      <div className="card-body bg-light p-4 p-md-5">
                        <div className="d-flex align-items-start mb-4">
                          <div
                            className="bg-success bg-gradient text-white rounded-circle d-flex align-items-center justify-content-center me-4 flex-shrink-0"
                            style={{ width: "40px", height: "40px" }}
                          >
                            <i className="fa fa-question-circle fs-4"></i>
                          </div>
                          <div>
                            <h3 className="fw-bold text-dark mb-2">
                              General Queries
                            </h3>
                            <p className="text-muted mb-3">
                              For all other questions and general inquiries
                            </p>
                          </div>
                        </div>

                        <div className="ps-0 ps-md-5 ms-0 ms-md-4">
                          <div className="mb-3">
                            <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                              <i className="fa fa-envelope text-success"></i>
                              <span className="text-muted">Primary:</span>
                              <a
                                href="mailto:shalini.sahay@metropolisindia.com"
                                className="text-success fw-semibold info-link"
                              >
                                shalini.sahay@metropolisindia.com
                              </a>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                              <i className="fa fa-envelope text-success"></i>
                              <span className="text-muted">Secondary:</span>
                              <a
                                href="mailto:jeyasingh.b@metropolisindia.com"
                                className="text-success fw-semibold info-link"
                              >
                                jeyasingh.b@metropolisindia.com
                              </a>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                              <i className="fa fa-paper-plane text-success"></i>
                              <span className="text-muted">Copy to:</span>
                              <a
                                href="mailto:academics.sciencecell@metropolisindia.com"
                                className="text-success fw-semibold info-link"
                                title="academics.sciencecell@metropolisindia.com"
                              >
                                academics.sciencecell@metropolisindia.com
                              </a>
                            </div>
                          </div>
                        </div>

                        <div
                          className="position-absolute bottom-0 start-0 w-100"
                          style={{
                            height: "4px",
                            background:
                              "linear-gradient(90deg, #25D366, #128C7E)",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* WhatsApp & Direct Contact Cards */}
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="card border-0 shadow-sm rounded-5 h-100 position-relative overflow-hidden hover-lift">
                      <div className="card-body bg-light p-4 text-center">
                        <div
                          className="bg-success bg-gradient text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
                          style={{ width: "40px", height: "40px" }}
                        >
                          <i className="fa fa-whatsapp fs-2"></i>
                        </div>
                        <h4 className="fw-bold text-dark mb-3">
                          WhatsApp Support
                        </h4>
                        <p className="text-muted mb-4">
                          Quick responses via WhatsApp or phone call
                        </p>
                        <div className="d-grid">
                          <a
                            href="https://wa.me/919152211510"
                            className="btn-view phn-num"
                          >
                            <i className="fa fa-whatsapp me-2"></i>+91
                            9152211510
                          </a>
                        </div>
                      </div>
                      <div
                        className="position-absolute bottom-0 start-0 w-100"
                        style={{
                          height: "4px",
                          background:
                            "linear-gradient(90deg, #25D366, #128C7E)",
                        }}
                      ></div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card border-0 bg-light shadow-sm rounded-5 h-100 position-relative overflow-hidden hover-lift">
                      <div className="card-body p-4 text-center">
                        <div
                          className="bg-success bg-gradient text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
                          style={{ width: "40px", height: "40px" }}
                        >
                          <i className="fa fa-phone fs-2"></i>
                        </div>
                        <h4 className="fw-bold text-dark mb-3">
                          Direct Contact
                        </h4>
                        <p className="text-muted mb-4">
                          Speak directly with our team members
                        </p>
                        <div className="d-grid gap-2">
                          <a
                            href="tel:+919310554590"
                            className="btn-view phn-num"
                          >
                            <i className="fa fa-phone me-1"></i> Shalini Sahay:
                            +91 9310554590
                          </a>
                          <a
                            href="tel:+918928286168"
                            className="btn-view phn-num"
                          >
                            <i className="fa fa-phone me-1"></i> Jeyasingh B:
                            +91 8928286168
                          </a>
                        </div>
                      </div>
                      <div
                        className="position-absolute bottom-0 start-0 w-100"
                        style={{
                          height: "4px",
                          background:
                            "linear-gradient(90deg, #25D366, #128C7E)",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Styles */}
        <style jsx>{`
          .hover-lift {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .hover-lift:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15) !important;
          }

          .btn {
            transition: all 0.3s ease;
          }

          .card {
            transition: all 0.3s ease;
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .card {
            animation: fadeInUp 0.6s ease forwards;
          }

          /* Responsive email/phone alignment */
          @media (max-width: 767px) {
            .d-flex.flex-md-row {
              flex-direction: column !important;
              align-items: flex-start;
            }
          }
        `}</style>
      </main>
    </>
  );
};

export default ContactUs;
